import http from './http';
import { handleResponse } from '@/shared/utils/promise-helpers';

export default {
  getQueuesWhatsApp() {
    return http.get('/queues/whatsapp', { params: { without_paginate: true } });
  },

  getQueuesWhatsAppByOrg(org) {
    return http.get(`/queues/whatsapp/agent/org-unit/${org}`);
  },

  getQueueWhatsAppById(id) {
    return id ? http.get(`/queues/whatsapp/${id}`) : { data: null };
  },

  getCampaignWhatsAppById(id) {
    return id ? http.get(`/campaigns/whatsapp/${id}`) : { data: null };
  },

  getWhatsappRoutesCampaign(id) {
    return id ? http.get(`/campaigns/whatsapp/routes/${id}`) : { data: null };
  },

  getWhatsappRoutesQueue(from) {
    return from ? http.get(`/queues/whatsapp/routes/${from}`) : { data: null };
  },

  getWhatsappTemplatesMessages(id) {
    return id
      ? http.get(`/campaigns/whatsapp/templates-messages/${id}`)
      : { data: null };
  },

  getInfobipWhatsappTemplatesMessages(params) {
    return http.get('/infobip/templates', { params });
  },

  getZenviaWhatsappTemplatesMessages() {
    return http.get('/zenvia/templates');
  },

  getGupshupWhatsappTemplatesMessages(org, route) {
    return http.get(`/gupshup/templates/${org}/${route}`);
  },

  getGupshupWhatsappTemplatesMessagesByGroup(group) {
    return http.get(`/gupshup/templates/group/${group}`);
  },

  getScriptQueue(id) {
    return http.get(`/queues/whatsapp/${id}/script`);
  },

  getScriptCampaign(id) {
    return http.get(`/campaigns/whatsapp/${id}/script`);
  },

  getWhatsappAllMidia(params) {
    return http.get('contacts/media/whatsapp', { params });
  },

  getConversationList(params) {
    return http.get('whatsapp/messages/search', { params });
  },

  setGupshupUserOptin(user) {
    return http.post('/gupshup/set-optin', { user });
  },

  searchMessageAnswered(message_id) {
    return http.get(`/whatsapp/message/${message_id}`);
  },
};

export const activeJobWhatsapp = (informations) =>
  http.post('/job/whatsapp/active-job', informations);

export const whatsappQualify = (qualify) =>
  http.post('/job/whatsapp/qualify', qualify);

export const whatsappTransfer = (informations) =>
  http.post('/job/whatsapp/transfer', informations);

export const whatsappReopen = (informations) =>
  http.post('whatsapp/reopen', informations).then(handleResponse);

export const numberHasWhatsapp = (informations) =>
  http
    .get('whatsapp/number-has-whatsapp', { params: informations })
    .then(handleResponse);

export const sendWhatsAppVoiceCallPermission = (informations) =>
  http.post('/whatsapp/voice-call-permission', informations);
